import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=f0ded13c&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=ts"
export * from "./Thread.vue?vue&type=script&lang=ts"
import style0 from "./Thread.vue?vue&type=style&index=0&id=f0ded13c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ded13c",
  null
  
)

export default component.exports